import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { APIResponse } from '@shared-models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class CoreHttpService {
  //#region Service properties

  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  //#endregion

  //#region Service methods

  protected get<T>(slug: string, params: HttpParams | null = null): Observable<T> {
    return this.http
      .get<APIResponse<T>>(`${this.apiUrl}${slug}`, params ? { params } : {})
      .pipe(map(response => response.data));
  }

  protected post<T>(slug: string, body: unknown): Observable<T> {
    return this.http
      .post<APIResponse<T>>(`${this.apiUrl}${slug}`, body)
      .pipe(map(response => response.data));
  }

  protected put<T>(slug: string, body: unknown): Observable<T> {
    return this.http
      .put<APIResponse<T>>(`${this.apiUrl}${slug}`, body)
      .pipe(map(response => response.data));
  }

  protected patch<T>(slug: string, body: unknown): Observable<T> {
    return this.http
      .patch<APIResponse<T>>(`${this.apiUrl}${slug}`, body)
      .pipe(map(response => response.data));
  }

  protected delete(slug: string): Observable<unknown> {
    return this.http.delete(`${this.apiUrl}${slug}`);
  }

  protected getBlob(slug: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}${slug}`, { responseType: 'blob' });
  }

  protected convertFiltersToQueryParams(filters: object): string {
    const params = new URLSearchParams();
    Object.entries(filters)
      .filter(([, value]) => !!value)
      .forEach(([key, value]) => {
        params.append(key, value);
      });
    return params.toString();
  }

  //#endregion
}
